module.exports = __webpack_public_path__ + "img/life@Q_qacademy.de98030f.jpg";